export const NAME = 'user';

export const USER_TEMPLATE_TYPES = {
    GENERAL: 'general',
    HISTORY: 'history',
};
